jQuery(document).ready(function($) {
  //Donate on change
  var dataForm = null;
  $('.donate-tabs .tab').click(function(e) {
    e.preventDefault();
    // set tabs
    $('.donate-tabs .tab').removeClass('active');
    $('.donate-form').removeClass('active');
    $(this).addClass('active');
    // get the right from
    dataForm = $(this).attr('data-formtype');
    $('.' + dataForm).addClass('active');
    // reset inputs
    $('.quick-amouunts .amount input[type=radio]').prop('checked', false);
    $('.quick-amouunts .amount').removeClass('active');
    $('.other-amount input')
      .attr('value', null)
      .inputmask({ clearMaskOnLostFocus: true });
  });

  $('.donate-submit').prop('disabled', true);

  $('.quick-amouunts .amount').click(function(e) {
    e.preventDefault();
    $('.quick-amouunts .amount').removeClass('active');
    $(this).addClass('active');
    $(this)
      .find('input[type=radio]')
      .prop('checked', true);
    // reset inputs
    $('.donate-submit').prop('disabled', false);
    $('.other-amount input')
      .attr('value', null)
      .inputmask({ clearMaskOnLostFocus: true });
  });

  $('.other-amount input').focusin(function() {
    $(this).inputmask({ alias: 'currency', prefix: '', rightAlign: false });
    // reset inputs
    $('.quick-amouunts .amount').removeClass('active');
    $('.quick-amouunts .amount input').prop('checked', false);
    $('.donate-submit').prop('disabled', false);
  });

  // Mobile Menu

  $('#mobile-menu').click(function() {
    $('header').toggleClass('mobile-active');

    if ($('header').hasClass('mobile-active')) {
      $('body, html').css('overflow-y', 'hidden');
    } else {
      $('body, html').css('overflow-y', 'auto');
    }
  });

  var itemHasChildren = $('.menu-item-has-children');
  itemHasChildren.append('<span class="expand-child-items"><i class="far fa-angle-down"></i></span>');

  $('.expand-child-items').click(function() {
    $(this).toggleClass('active');
    $(this)
      .parent('.menu-item-has-children')
      .find('ul')
      .first()
      .toggleClass('active');
  });

  // Header Scroll

  $(window).scroll(function(event) {
    var yOffset = window.pageYOffset;
    var breakpoint = 50;

    if (yOffset > breakpoint) {
      $('header').addClass('active');
    } else {
      $('header').removeClass('active');
    }
  });

  // Header Search

  $('.slide-open').click(function() {
    var form = $('.search-bar');
    var inputVal = form.find('input').val();

    if (inputVal) {
      form.submit();
    } else {
      $('header').toggleClass('form-active');
    }
  });

  // Home Signup

  $('.signup-open').click(function() {
    $('.section-signup').addClass('form-active');

    $('.slide-close').click(function() {
      $('.section-signup').removeClass('form-active');
    });
  });

  // Member Popup

  $('.member-listing .member').live('click', function(e) {
    e.preventDefault();

    var url = $(this).attr('href');

    $('#member-popup').load(url + ' main .single-member', function() {
      $('body').addClass('popup-active');

      $('.popup-close').click(function() {
        $('body').removeClass('popup-active');
      });

      $(document).keyup(function(e) {
        if (e.keyCode == 27) {
          $('body').removeClass('popup-active');
        }
      });
    });
  });

  // Accordion

  $('.accordion-item-title').click(function() {
    var accordionContent = $(this).next('.accordion-item-content');
    var accordionContentHeight = accordionContent[0].scrollHeight;
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
      accordionContent.css('max-height', `${accordionContentHeight}px`);
    } else {
      accordionContent.css('max-height', `0px`);
    }
  });
});

// Sliders

jQuery(window).load(function() {
  jQuery('.slider').flickity({
    autoPlay: 8000,
    prevNextButtons: true,
    imagesLoaded: true,
    pageDots: false,
    setGallerySize: true,
    wrapAround: true
  });

  jQuery('.product-slider').flickity({
    prevNextButtons: false,
    imagesLoaded: true,
    pageDots: false,
    setGallerySize: true,
    wrapAround: true
  });

  jQuery('.product-slider-nav').flickity({
    asNavFor: '.product-slider',
    cellAlign: 'left',
    prevNextButtons: false,
    imagesLoaded: true,
    pageDots: false,
    setGallerySize: true,
    wrapAround: true
  });

  jQuery('.slider').addClass('loaded');
});
